import { COLORS, DEVICES, FONT_FAMILY } from '@Commons';
import styled from 'styled-components';

export const SuccessPageWrapper = styled.div`
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OuterWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-items: center;
  justify-content: center;
`;

export const Wrapper = styled.div`
  width: 335px;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-items: center;
  text-align: center;

  .heading {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 18px;
    line-height: 26px;
    margin-top: 8px;
    color: black;
  }
  .subHeading {
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 16px;
    line-height: 22px;
    margin-top: 8px;
    color: ${COLORS.textGrey};
  }
  .bottomMargin48 {
    margin-bottom: 16px;
  }
  .bottomMargin24 {
    margin-bottom: 24px;
  }
  .bottomMargin48 {
    margin-bottom: 48px;
  }
  .primaryButton {
    margin-top: 32px;
  }
  .seondaryButton {
    width: 100%;
  }

  .sub2Heading {
    font-family: ${FONT_FAMILY.hellix.regular};
    margin-top: 8px;
    color: ${COLORS.textGrey};
    font-size: 14px;
    line-height: 18px;
    text-align: center;
  }

  .optionsDescription {
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 16px;
    line-height: 22px;
    margin-top: 8px;
    color: ${COLORS.textGrey};
    margin: 16px 0;
    color: black;
  }

  @media ${DEVICES.mobileXL} {
    width: 100%;
  }
  .userImg {
    margin-top: 48px;
    float: none;
  }
`;

export const ProvideAddressHeading = styled.div`
  margin-top: 40px;
  padding-top: 10px;
  font-size: 16px;
  line-height: 22px;
  font-family: ${FONT_FAMILY.hellix.regular};
  color: ${COLORS.textGrey};
`;

export const PersonalInfoContainer = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  width: 100%;

  .radio-fatca-wrapper {
    margin-top: 32px;
    position: relative;
    .label-text {
      font-family: ${FONT_FAMILY.hellix.bold};
    }
    .radio-fields {
      font-family: ${FONT_FAMILY.hellix.regular};
      margin: 18px 4px 10px 0;
    }
    .radio-button-error {
      left: 0;
    }
  }

  .submitBtnContainer {
    display: flex;
    justify-content: center;
    margin-top: 48px;
  }
`;

export const PersonalInfoHeading = styled.div`
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 18px;
  line-height: 26px;
  color: black;
  margin-bottom: 24px;
`;

export const AddressVerificationContainer = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  width: 100%;

  .heading {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 18px;
    line-height: 26px;
    color: black;
  }

  .subHeading {
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 16px;
    line-height: 22px;
    color: ${COLORS.textGrey};
    margin-top: 12px;
  }
`;

export const AddressVerificationContainerInner = styled.div`
  width: 450px;
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  @media ${DEVICES.mobileXL} {
    width: 90%;
  }
`;

export const AddressButtonContainer = styled.div`
  margin: 48px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
